import React, { Component } from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import TableAdd from './table_add';
import TableEdit from './table_edit';
import TableList from './table_list';


class TableSetting extends Component {
  render() {
    return ( <Switch>
        <Route path="/settings/tables/:table_id/edit" component={TableEdit}/>
        <Route path="/settings/tables/add" component={TableAdd}/>
        <Route path="/settings/tables" component={TableList}/>
        <Redirect from="*" to= "/settings/tables"/>
    </Switch>
    );
  }
}

export default TableSetting;
